{
  "Back to the Dashboard": "Back to the Dashboard",
  "Error verifying mobile number": "Error verifying mobile number",
  "Go back to users": "Go back to users",
  "Mobile number verified": "Mobile number verified",
  "Success": "Success",
  "Uh-Oh!": "Uh-Oh!",
  "Verifying the link...": "Verifying the link...",
  "We encountered an issue verifying your mobile number. Your link may be expired. Please re-send the verification and try again.": "We encountered an issue verifying your mobile number. Your link may be expired. Please re-send the verification and try again.",
  "Your mobile number has been verified for use by Weave.": "Your mobile number has been verified for use by Weave."
}
